import ListPractitioners from "./List";

export default ListPractitioners;
